import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useTheme } from "@mui/material/styles";

const CopyLinkIcon = React.forwardRef(function CopyLinkIcon(props, ref) {
  const { sx, ...rest } = props;
  const theme = useTheme();
  const primary = theme.palette?.primary?.main || "#FFEE20";

  return (
    <SvgIcon
      {...rest}
      ref={ref}
      viewBox="0 0 23 24"
      sx={{
        fontSize: 24,
        ...sx,
      }}
    >
      <path
        d="M16.9214 14.828L15.5663 13.414L16.9214 12C17.2774 11.6286 17.5597 11.1876 17.7524 10.7023C17.945 10.217 18.0442 9.69681 18.0442 9.1715C18.0442 8.6462 17.945 8.12605 17.7524 7.64073C17.5597 7.15542 17.2774 6.71445 16.9214 6.343C16.5654 5.97156 16.1428 5.67691 15.6777 5.47589C15.2126 5.27487 14.7142 5.1714 14.2107 5.1714C13.7073 5.1714 13.2089 5.27487 12.7438 5.47589C12.2787 5.67691 11.8561 5.97156 11.5001 6.343L10.145 7.757L8.78994 6.343L10.145 4.929C11.2263 3.81892 12.6842 3.19966 14.2011 3.2061C15.7179 3.21255 17.1709 3.84418 18.2435 4.96341C19.3161 6.08265 19.9214 7.5988 19.9276 9.18162C19.9338 10.7644 19.3403 12.2857 18.2765 13.414L16.9214 14.828V14.828ZM14.2103 17.657L12.8552 19.071C12.3229 19.6356 11.6887 20.0846 10.9892 20.3922C10.2897 20.6998 9.5388 20.8598 8.77976 20.863C8.02073 20.8662 7.26859 20.7126 6.56674 20.411C5.86489 20.1094 5.22721 19.6658 4.69048 19.1057C4.15376 18.5456 3.72862 17.8802 3.43957 17.1479C3.15053 16.4155 3.0033 15.6307 3.0064 14.8386C3.00949 14.0466 3.16283 13.263 3.45758 12.5331C3.75233 11.8033 4.18265 11.1415 4.72373 10.586L6.07881 9.172L7.4339 10.586L6.07881 12C5.72285 12.3714 5.44048 12.8124 5.24783 13.2977C5.05518 13.783 4.95603 14.3032 4.95603 14.8285C4.95603 15.3538 5.05518 15.874 5.24783 16.3593C5.44048 16.8446 5.72285 17.2856 6.07881 17.657C6.43478 18.0284 6.85737 18.3231 7.32247 18.5241C7.78756 18.7251 8.28605 18.8286 8.78946 18.8286C9.29287 18.8286 9.79136 18.7251 10.2564 18.5241C10.7215 18.3231 11.1441 18.0284 11.5001 17.657L12.8552 16.243L14.2103 17.657ZM14.2103 7.757L15.5663 9.172L8.78994 16.242L7.4339 14.828L14.2103 7.758V7.757Z"
        fill={primary}
      />
    </SvgIcon>
  );
});

export default CopyLinkIcon;
